import React, { FC } from 'react';
import { Grid } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { useStyles } from './styles';
import TitleField from './fields/TitleField';
import TypeField from './fields/TypeField';
import DescriptionField from './fields/DescriptionField';
import DateField from './fields/DateField';
import TimeField from './fields/TimeField';
import PublicEventSwitch from './fields/PublicEventSwitch';
import RegularPaymentSwitch from './fields/RegularPaymentSwitch';
import TicketsNumberField from './fields/TicketsNumberField';
import PriceField from './fields/PriceField';
import NftCollectionsField from './fields/NftCollectionsField';
import CoinsField from './fields/CoinsField';
import { EventValues } from './config';
import { CurrentUserReducer, RootReducer } from '../../../../models/Redux';

interface Props {
    values: EventValues;
    handleChange: (e: React.ChangeEvent<any>) => void;
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
    maximumTicketsNumber: number;
}

const EventForm: FC<Props> = ({ values, handleChange, setFieldValue, maximumTicketsNumber }) => {
    const classes = useStyles();

    const {
        influencer: { influencer_massive_streaming },
    } = useSelector<RootReducer, CurrentUserReducer>(state => state.currentUser);

    return (
        <>
            <TypeField
                disabled={!influencer_massive_streaming}
                value={values.type}
                handleChange={handleChange}
            />
            <TitleField value={values.title} handleChange={handleChange} />
            <DescriptionField value={values.description} handleChange={handleChange} />

            <Grid container className={classes.formGridRow}>
                <Grid item>
                    <DateField value={values.date} setFieldValue={setFieldValue} />
                </Grid>
                <Grid item>
                    <TimeField value={values.date} setFieldValue={setFieldValue} />
                </Grid>
                <Grid item>
                    <PublicEventSwitch value={values.public} handleChange={handleChange} />
                </Grid>
            </Grid>

            <RegularPaymentSwitch value={values.pricingEnabled} handleChange={handleChange} />

            <Grid container className={classes.formGridRow}>
                <Grid item>
                    <TicketsNumberField
                        value={values.tickets}
                        setFieldValue={setFieldValue}
                        maximumTicketsNumber={maximumTicketsNumber as number}
                    />
                </Grid>

                {values.pricingEnabled && (
                    <Grid item>
                        <PriceField value={values.price} setFieldValue={setFieldValue} />
                    </Grid>
                )}
            </Grid>

            {!values.pricingEnabled && (
                <>
                    <NftCollectionsField value={values.nftCollections} setFieldValue={setFieldValue} />
                    <CoinsField value={values.coins} setFieldValue={setFieldValue} />
                </>
            )}
        </>
    );
};

export default EventForm;
